import { render, staticRenderFns } from "./SidebarComposeMessageContact.vue?vue&type=template&id=3bdb9625&"
import script from "./SidebarComposeMessageContact.vue?vue&type=script&lang=js&"
export * from "./SidebarComposeMessageContact.vue?vue&type=script&lang=js&"
import style0 from "./SidebarComposeMessageContact.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports